if (document.getElementById('ticketQuery')) {
    var formQA = new Vue({
        el: '#ticketQuery',
        data: () => ({
            loading: false,
            ticket: {
                ticketReferenceID: qsReferenceID,
                ticketEmail: qsEmail
            },
            responseHasError: false,
            emailHasError: false,
            referenceIdHasError: false,
            responseData: null,
            incTicket: false
        }),
        mounted() {
            this.loading = true;
            this.sendTicket();
        },
        methods: {            
            sendTicket() {

                const self = this;
                self.loading = true;
                if (this.ticket.ticketReferenceID.toUpperCase().indexOf('ENQ') == 0 || this.ticket.ticketReferenceID.toUpperCase().indexOf('QRY') == 0 || this.ticket.ticketReferenceID.toUpperCase().indexOf('GEM') == 0) {
                    axios.post('/umbraco/api/ContactApi/CheckTicketStatus', {
                        referenceID: qsReferenceID,
                        email: qsEmail
                    })
                        .then(function (response) {
                            self.responseData = response.data;
                            if (!self.responseData.MPRN) {
                                self.responseData.MPRN = "N/A"
                            }
                            if (response.data.ResponseCode != 200) {
                                var newurl = "/help-and-support/check-status-of-an-existing-support-request/?ReferenceID=" + self.ticket.ticketReferenceID + "&Email=" + self.ticket.ticketEmail;
                                window.location.href = newurl;
                            }
                            self.loading = false;
                        })
                        .catch(function (error) {
                            self.loading = false;
                            console.log(error);
                            return false;
                        })
                }
            }

        },    
        watch: {
            loading() {
                if (this.loading) {
                    $('html').addClass("loading")
                } else {
                    $('html').removeClass("loading")
                }
            }
        }
    }) 
}
